import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationTriangle, FaSpinner } from 'react-icons/fa';
import SEO from '../components/SEO';

const ActivateAccount = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const activationAttempted = useRef(false); // Sử dụng useRef để theo dõi việc gọi API
  
  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Token kích hoạt không hợp lệ.');
      return;
    }
    
    const activateAccount = async () => {
      // Kiểm tra xem đã thử kích hoạt chưa
      if (activationAttempted.current) return;
      activationAttempted.current = true;
      
      try {
        const response = await fetch(`/api/auth/activate/${token}`);
        const data = await response.json();
        
        console.log("Kết quả API:", data);
        
        if (data.success === true) {
          setStatus('success');
          setMessage(data.message);
        } else {
          setStatus('error');
          setMessage(data.message || 'Không thể kích hoạt tài khoản.');
        }
      } catch (error) {
        console.error('Lỗi kích hoạt tài khoản:', error);
        setStatus('error');
        setMessage('Đã xảy ra lỗi khi kết nối đến máy chủ. Vui lòng thử lại sau.');
      }
    };
    
    activateAccount();
  }, [token]);
  
  return (
    <>
      <SEO 
        title="Kích hoạt tài khoản" 
        description="Kích hoạt tài khoản của bạn tại PSA Roleplay"
        noIndex={true}
      />
      
      {/* <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Kích hoạt tài khoản",
              "description": "Kich hoạt tài khoản PSA Roleplay của bạn để trải nghiệm máy chủ tốt nhất.",
              "publisher": {
                "@type": "Organization",
                "name": "PSA Roleplay",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://psa.world/resources/images/logo_project.png"
                }
              }
            }
          `}
        </script>
      </Helmet> */}
      
      <div className="min-h-screen pt-24 pb-16 relative">
        <div 
          className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/resources/images/gta-bg.png')` }}
        ></div>
        
        <div className="absolute inset-0 bg-grid-pattern opacity-10 z-0"></div>
        
        <div className="absolute top-1/3 left-1/4 w-72 h-72 bg-accent-teal/20 rounded-full filter blur-[100px] -z-10 animate-pulse"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-md mx-auto">
            <motion.div 
              className="glassmorphism-card p-6 md:p-8 relative overflow-hidden shadow-xl border border-white/10"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="text-center mb-8">
                <h1 className="text-2xl md:text-3xl font-bold mb-2">
                  <span className="text-gradient-teal">Kích hoạt tài khoản</span>
                </h1>
              </div>
              
              <div className="flex flex-col items-center justify-center py-8">
                {status === 'loading' && (
                  <motion.div 
                    className="flex flex-col items-center"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    <FaSpinner className="text-accent-teal text-4xl animate-spin mb-4" />
                    <p className="text-light">Đang kích hoạt tài khoản của bạn...</p>
                  </motion.div>
                )}
                
                {status === 'success' && (
                  <motion.div 
                    className="flex flex-col items-center text-center"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FaCheckCircle className="text-green-500 text-5xl mb-4" />
                    <h2 className="text-xl font-bold mb-2">Kích hoạt thành công!</h2>
                    <p className="text-light/80 mb-6">{message}</p>
                    <Link 
                      to="/login" 
                      className="btn btn-primary py-2 px-6 rounded-lg"
                    >
                      Đăng nhập ngay
                    </Link>
                  </motion.div>
                )}
                
                {status === 'error' && (
                  <motion.div 
                    className="flex flex-col items-center text-center"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FaExclamationTriangle className="text-red-500 text-5xl mb-4" />
                    <h2 className="text-xl font-bold mb-2">Không thể kích hoạt</h2>
                    <p className="text-light/80 mb-6">{message}</p>
                    <div className="flex gap-4">
                      <Link 
                        to="/register" 
                        className="btn btn-secondary py-2 px-6 rounded-lg"
                      >
                        Đăng ký mới
                      </Link>
                      <Link 
                        to="/help" 
                        className="btn btn-outline py-2 px-6 rounded-lg"
                      >
                        Trợ giúp
                      </Link>
                    </div>
                  </motion.div>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivateAccount;
